import React from 'react';

const SchemesToUpdate = ({ schemes }) => {
  if (!schemes) {
    return null;
  }

  if (!schemes.length) {
    return (
      <div>
        {' '}
        No Test Schemes Found to Update. Create Test Schemes to enable this functionality
      </div>
    );
  }
  return (
    <>
      <div> The below scheme groups will be updated when saved</div>
      <ul>
        {schemes.map((scheme) => (
          <li>
            {scheme.name} v{scheme.version}
          </li>
        ))}
      </ul>
    </>
  );
};

export default SchemesToUpdate;
